import { Button, Card, Image } from "react-bootstrap";
import { useApp } from "common/context";
import { FaCloud, FaMicrosoft } from "react-icons/fa";

import gmetrix_logo from "common/assets/logo_gmetrix.png";
import { FormattedMessage } from "react-intl";

export const Login = props => {

    const { tryMSLogin } = useApp();

    return (
        <Card className="login">
            <Card.Body className="p-md-5 px-3 py-5">
                <div className="d-flex align-items-center gap-1">
                    <div className="d-flex me-3 align-items-center">
                        <FaCloud size={50} className="text-secondary" />
                    </div>
                    <div>
                        <div className="flex-fill">
                            <Image src={gmetrix_logo} fluid width={300} height={36} />
                        </div>
                        <h4 className="fw-normal">
                            <FormattedMessage
                                id="label.cloud_testing_management"
                                defaultMessage="Cloud Testing Management"
                            />
                        </h4>
                    </div>
                </div>
                <Button size="lg" className="mt-4 m-auto d-flex align-items-center gap-2" onClick={tryMSLogin}>
                    <FaMicrosoft />
                    <FormattedMessage
                        id="label.sign_in_with_microsoft"
                        defaultMessage="Sign in with Microsoft"
                        />
                </Button>
            </Card.Body>
        </Card>
    );

};